(function ($, once) {

  'use strict';

  var scrollPos;
  var windowWidth;
  var windowHeight;
  var windowRatio;
  var escKey = 'Escape';

  /* CLICK ELEMENTS */
  var $contentRevealToggle = $('.content-reveal-toggle');
  var $stayInspired = $('.block-menu-utility .nav-email');
  var $emailsignup = $('.email-signup--inner .button');
  var $emailSignUpBikeTnModal = $('.biketn-header-nav .nav-email');
  var $modalClose = $('.js-modal-close');
  var $featurePlay = $('.js-play-featured');
  var $shareFacebook = $('.js-fb-share');
  var $shareTwitter = $('.js-tw-share');
  var $sharePinterest = $('.js-pt-share');
  var $closeMessages = $('.js-close-messages');

  /* DOM ELEMENTS */
  var $body = $('body');
  var $contentOuter = $('.content-reveal-outer');
  var $contentInner = $('.content-reveal-inner');
  var $statusMessage = $('.status-messages');
  var $homeHero = $('.paragraph--type-home-hero');
  var $hero = $('.hero-image-section');
  var $preFooterAd = $('.view-pre-footer-ad .views-row');
  var $contentGrouping = $('.component-content-grouping');
  var $heroSliderWrap = $('.paragraph--type-hero-slider');
  var $articlePreview = $('.section.hero .article-preview');

  /* FORM ELEMENTS */
  var $emailSignUp = $('#form-email-signup');
  var $emailSignUpBikeTnSubmit = $('#form-email-signup-bike-tn');
  var $emailFirstSignUp = $('#form-first-email-signup');
  var $emailInteractionSignUp = $('#form-interactions-email-signup');
  var $emailTextBlockSignUp = $('#form-email-text-block-signup');

  /* INITIALIZE OBJECT FIT IMAGES LIBRARY */
  objectFitImages(); // eslint-disable-line no-undef

  /* INITIALIZE ^ WHERE BREAKPOINTS AFFECT OBJECT-FIT STYLES */
  objectFitImages('.section.hero .hero-image img', {watchMQ: true}); // eslint-disable-line no-undef
  objectFitImages('.section.hero .hero-image img', {watchMQ: true}); // eslint-disable-line no-undef
  objectFitImages('.component-campaign-callout__bg-img img', {watchMQ: true}); // eslint-disable-line no-undef
  objectFitImages('.component-campaign-callout__bg-img-mobile img', {watchMQ: true}); // eslint-disable-line no-undef

  /* CHECK FOR OPEN MODAL */
  if ((document.referrer === '' || document.referrer === 'undefined') && window.location.href.indexOf('#') > -1) {
    var cleanHash = window.location.hash.split('?');
    var $modalVideo = $(cleanHash[0]);

    // Only add body class if hash is a link to a modal video.
    if ($modalVideo && $modalVideo.hasClass('modal')) {
      $('body').addClass('modal-active');
    }
  }

  /* CLICK EVENTS */

  // Share on Facebook.
  $shareFacebook.on('click', function (e) {
    e.preventDefault();
    shareFacebook($(this).attr('data-fb-link'));
  });

  // Share on Twitter.
  $shareTwitter.on('click', function (e) {
    e.preventDefault();
    $(this).attr('href', shareTwitter($(this).attr('data-tw-message')));
  });

  // Share on Pinterest.
  $sharePinterest.on('click', function (e) {
    e.preventDefault();
    PinUtils.pinAny(); // eslint-disable-line no-undef
  });

  // Event when closing modal.
  $modalClose.on({
    click: function (e) {
      modalInactive();
      if (typeof pausePlayer === 'function') {
        pausePlayer(); // eslint-disable-line no-undef
      }
      $(this).closest('.embedded-content-wrapper, .itinerary-stop').removeClass('modal-active-current');
      window.location.hash = 'back';
      history.pushState('', document.title, window.location.pathname); // Nice and clean.

      e.preventDefault();
    },
    keydown: function (e) {
      if (e.key === escKey) {
        if (typeof pausePlayer === 'function') {
          pausePlayer(); // eslint-disable-line no-undef
        }
        modalInactive();
        $(this).closest('.embedded-content-wrapper').removeClass('modal-active-current');
        window.location.hash = 'back';
        history.pushState('', document.title, window.location.pathname); // Nice and clean.
      }
    }
  });

  // Event when closing modal.
  $closeMessages.on('click', function (e) {
    $statusMessage.hide();

    e.preventDefault();
  });

  // Event when clicking play button.
  $featurePlay.on({
    click: function (e) {
      if ($(this).parents('.section.hero').length === 1) {
        window.scrollTo(0, 0);
      }
      playPlayer($(this).data('vid')); // eslint-disable-line no-undef
      $(this).closest('.embedded-content-wrapper, .itinerary-stop').addClass('modal-active-current');
      modalActive();

      // Set focus on modal close button.
      var $currentModal = $(this).closest('.js-featured-video__wrapper').find('.modal');
      var $currentCloseModal = $currentModal.find('.js-modal-close');
      if ($currentCloseModal.length > 0) {
        setTimeout(function () {
          $currentCloseModal[0].focus();
        }, 300);
      }
    }
  });

  // Event when clicking email sign up menu link.
  $stayInspired.add($emailsignup).on({
    click: function (e) {
      window.location.hash = 'email-signup';
      modalActive();

      // Set focus on modal close button.
      var $emailModalClose = $('#block-emailmodal .modal .js-modal-close');
      setTimeout(function () {
        $emailModalClose.focus();
      }, 300);
    }
  });
  $emailSignUpBikeTnModal.off('click');
  $emailSignUpBikeTnModal.on({
    click: function (e) {
      window.location.hash = 'email-signup-biketn';
      modalActive();

      // Set focus on modal close button.
      var $emailModalClose = $('#block-emailmodal .modal .js-modal-close');
      setTimeout(function () {
        $emailModalClose.focus();
      }, 300);
    }
  });

  $contentRevealToggle.on('click', function (e) {
    var contentHeight = $(this).parent().find($contentInner).innerHeight();
    var parent = $(this).parent();

    if (parent.hasClass('collapsed')) {
      $(parent).css('height', contentHeight).removeClass('collapsed').addClass('expanded');
      $(parent).attr('aria-expanded', 'true');
    }
    else {
      $(parent).css('height', '').removeClass('expanded').addClass('collapsed');
      $(parent).attr('aria-expanded', 'false');
    }
    e.preventDefault();
  });


  function hideFirstTime() {
    $('body').removeClass('first-time');
  }

  // Add Lift values to guide forms.
  $(document).on('acquiaLiftWebSegments', function (event, segments, currentCapture) {
    if (segments != null) {
      if ($('.field--name-field-guide-lift-experience').length) {
        $.each(segments, function (index, value) {
          if (value.indexOf('experience') >= 0) {
            value = value.replace('experience_', '');
            $('input.field--name-field-guide-lift-experience').val(value);
          }
          else if (value.indexOf('destination') >= 0) {
            value = value.replace('destination_', '');
            $('input.field--name-field-guide-lift-destination').val(value);
          }
        });
      }
    }
  });

  $emailSignUp.on('submit', function (e) {
    $('.email-form').addClass('loading');
    e.preventDefault();
    var email = $(this).find('.email-input').val();
    if (isEmail(email)) {
      var newEmail = email.replace('+', '%2B');
      $.ajax('/mailchimp/add_contact_list_form_id/email_signup?email=' + newEmail)
        .done(function (data) {
          $('.email-form').hide();
          $('.email-success').show();
          $('.email-form').removeClass('loading');
          window.setTimeout(hideFirstTime, 3000);
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
          $('.email-form').addClass('error');
          $('.email-form').removeClass('loading');
        });
    }
    else {
      $('.email-form').addClass('error');
      $('.email-form').removeClass('loading');
    }
  });
  // BikeTN Signup

  $emailSignUpBikeTnSubmit.on('submit', function (e) {
    $('.email-form').addClass('loading');
    e.preventDefault();
    var email = $(this).find('.email-input').val();
    if (isEmail(email)) {
      var newEmail = email.replace('+', '%2B');
      $.ajax('/mailchimp/add_contact_list_form_id/biketn?email=' + newEmail)
        .done(function (data) {
          $('.email-form').hide();
          $('.email-success').show();
          $('.email-form').removeClass('loading');
          window.setTimeout(hideFirstTime, 3000);
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
          $('.email-form').addClass('error');
          $('.email-form').removeClass('loading');
        });
    }
    else {
      $('.email-form').addClass('error');
      $('.email-form').removeClass('loading');
    }
  });

  // Submit email signup.
  $emailFirstSignUp.on('submit', function (e) {
    $('#email-first-time .email-form').addClass('loading');
    e.preventDefault();
    var email = $(this).find('.email-input').val();
    if (isEmail(email)) {
      var newEmail = email.replace('+', '%2B');
      $.ajax('/mailchimp/add_contact_list_form_id/email_signup?email=' + newEmail)
        .done(function (data) {
          $('#email-first-time .email-form').hide();
          $('#email-first-time .email-success').show();
          $('#email-first-time .email-form').removeClass('loading');
          window.setTimeout(hideFirstTime, 3000);
          dataLayer.push({
            eventCategory: 'enewsletter',
            eventAction: 'sign-up',
            eventLabel: 'first time',
            eventvalue: '',
            event: 'eventClick'
          });
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
          $('#email-first-time .email-form').addClass('error');
          $('#email-first-time .email-form').removeClass('loading');
        });
    }
    else {
      $('#email-first-time .email-form').addClass('error');
      $('#email-first-time .email-form').removeClass('loading');
    }
  });

  // Submit interaction email signup.
  $emailInteractionSignUp.on('submit', function (e) {
    $('#email-interactions-pop-up .email-form').addClass('loading');
    e.preventDefault();
    var email = $(this).find('.email-input').val();
    if (isEmail(email)) {
      var newEmail = email.replace('+', '%2B');
      $.ajax('/mailchimp/add_contact_list_form_id/email_signup?email=' + newEmail)
        .done(function (data) {
          setCookie('tnvactive', 0, 30);
          $('#email-interactions-pop-up .email-form').hide();
          $('#email-interactions-pop-up .email-success').show();
          $('#email-interactions-pop-up .email-form').removeClass('loading');
          $('#block-emailinteractionspopup').addClass('submitted');
          window.setTimeout(hideFirstTime, 3000);
          Drupal.behaviors.analytics.hashString(email).then(hash => {
            dataLayer.push({
              eventCategory: 'enewsletter',
              eventAction: 'sign-up',
              eventLabel: 'site trigger',
              eventvalue: '',
              event: 'eventClick',
              hashedEmail: hash
            });
          });
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
          $('#email-interactions-pop-up .email-form').addClass('error');
          $('#email-interactions-pop-up .email-form').removeClass('loading');
        });
    }
    else {
      $('#email-interactions-pop-up .email-form').addClass('error');
      $('#email-interactions-pop-up .email-form').removeClass('loading');
    }
  });

  $emailTextBlockSignUp.on('submit', function (e) {
    $('.email-form').addClass('loading');
    e.preventDefault();
    var email = $(this).find('.email-input').val();
    if (isEmail(email)) {
      var newEmail = email.replace('+', '%2B');
      $.ajax('/mailchimp/add_contact_list_form_id/email_signup?email=' + newEmail)
        .done(function (data) {
          $('.email-form').hide();
          $('.email-success').show();
          $('.email-form').removeClass('loading');
          window.setTimeout(hideFirstTime, 3000);
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
          $('.email-form').addClass('error');
          $('.email-form').removeClass('loading');
        });
    }
    else {
      $('.email-form').addClass('error');
      $('.email-form').removeClass('loading');
    }
  });

  // Added common class to two sections in tmp page.
  $('.common-section').slice(0, 2).wrapAll('<div class="tmp-common-section"></div>');

  /* FUNCTIONS */

  function preFooterActive() {
    var count = $preFooterAd.length;

    if (count >= 2) {
      var random = Math.floor((Math.random() * count));
      $preFooterAd.eq(random).addClass('jsa-active');
      Drupal.blazy.init.revalidate();
    }
    else {
      $preFooterAd.addClass('jsa-active');
      Drupal.blazy.init.revalidate();
    }
  }

  /* eslint-disable */
  function shareFacebook(link) {

    if (link === undefined) {
      var fblink = document.URL;
    }
    else {
      var fblink = link;
    }

    var obj = {
      method: 'feed',
      link: fblink
    };

    function callback(response) { }
    FB.ui(obj, callback); // eslint-disable-line no-undef.
  }
  /* eslint-enable */

  function shareTwitter(text) {
    var url = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(text);
    window.open(url, '', 'menubar=0,resizable=0,scrollbars=0,width=550,height=450');
  }

  function contentRevealCheck() {
    $contentOuter.each(function () {
      var contentHeight = $(this).find($contentInner).innerHeight();
      var contentThreshold = 250;

      if (contentHeight >= contentThreshold) {
        $(this).addClass('content-reveal-active collapsed');
        $(this).attr('aria-expanded', 'false');
      }

      // Add aria-controls attribute to toggle link.
      var contentToggle = $(this).find('.content-reveal-toggle');
      contentToggle.attr('role', 'button');
      contentToggle.attr('aria-controls', $(this).attr('id'));
    });
  }

  function contentRevealResize() {
    $contentOuter.each(function () {
      var contentHeight = $(this).find($contentInner).innerHeight();

      if ($(this).hasClass('expanded')) {
        $(this).css('height', contentHeight);
      }
    });
  }

  function homeHeroRatio(element) {

    if (windowRatio >= 55) {
      element.addClass('stretch');
    }
    else {
      element.removeClass('stretch');
    }
  }

  function heroRatio(element) {

    if (windowRatio <= 100) {
      element.addClass('portrait');
    }
    else {
      element.removeClass('portrait');
    }
  }

  function contentGroupingRatio() {
    $('.component-content-grouping').each(function () {
      var elHeight = $(this).height();
      var elWidth = $(this).width();
      var elRatio = elHeight / elWidth * 100;

      if (elRatio <= 56.8) {
        $(this).removeClass('portrait');
      }
      else {
        $(this).addClass('portrait');
      }
    });
  }

  /* eslint-disable */
  // Floodlight Tag Tracking.
  function callStaticFL(source, type, cat) {
    var axel = Math.random() + "";
    var num = axel * 1000000000000000000;
    var tag_url = new Image();
    tag_url.src = "https://4384249.fls.doubleclick.net/activityi;src=" + source + ";type=" + type + ";cat=" + cat + ";ord=' + a + '?' width='1' height='1'";
  }
  /* eslint-enable */

  function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  }

  function modalActive() {
    $body.addClass('modal-active');
  }

  function modalInactive() {
    $body.removeClass('modal-active');
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  function getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  function checkCookie() {
    var tnvinteractions = getCookie('tnvinteractions');
    var tnvactive = getCookie('tnvactive');
    if (tnvinteractions !== '') {
      if (tnvactive !== '0') {
        setCookie('tnvinteractions', Number(tnvinteractions) + 1, 30);
        if (Number(getCookie('tnvinteractions')) >= 2) {
          displayEmailPopUp();
        }
      }
    }
    else {
      setCookie('tnvinteractions', 1, 30);
      setCookie('tnvactive', 1, 30);
    }
  }

  function displayEmailPopUp() {
    $('#block-emailinteractionspopup').addClass('active').attr('aria-hidden', 'false');
  }

  function hideEmailPopUp() {
    $('#block-emailinteractionspopup').removeClass('active').attr('aria-hidden', 'true');
  }

  /* Document Ready */

  $(document).ready(function () {
    var tnvinteractions = getCookie('tnvinteractions');
    var tnvactive = getCookie('tnvactive');
    if (tnvactive !== '1' && tnvactive !== '0') {
      setCookie('tnvactive', 1, 30);
    }
    if (tnvinteractions !== '' && tnvactive !== '0') {
      if (Number(tnvinteractions) > 1) {
        displayEmailPopUp();
      }
    }

    windowWidth = window.innerWidth;
    windowHeight = window.innerHeight;
    windowRatio = windowHeight / windowWidth * 100;

    contentRevealCheck();

    if ($preFooterAd.length) {
      preFooterActive();
    }

    if ($hero.length) {
      heroRatio($hero);
    }

    if ($contentGrouping.length) {
      contentGroupingRatio();
    }

    if ($homeHero.length) {
      homeHeroRatio($homeHero);
    }

    if ($heroSliderWrap.length) {
      homeHeroRatio($heroSliderWrap);
    }

    if ($('.title-eyebrow').length) {
      $('.title-eyebrow h2').arctext({radius: 1400});
    }


    $('a[href^=http]').each(function () {

      // NEW - excluded domains list.
      var excludes = [
        'tnvacation.com',
        'tnvacation.docksal',
        'localhost',
        'acquia-sites.com'
      ];

      for (var i = 0; i < excludes.length; i++) {
        if (this.href.indexOf(excludes[i]) !== -1) {
          return true; // Continue each() with next link.
        }
      }

      if (this.href.indexOf(location.hostname) === -1) {
        $(this).attr({
          target: '_blank'
        });
      }
    });

    if ($('.node--kid-reviewed-landing-page-full').length) {
      $('.region-footer-third').addClass('footer-kr-special');
    }
  });

  /* Window Resize */

  $(window).resize(function () {

    contentRevealResize();

    if ($homeHero.length) {
      windowWidth = window.innerWidth;
      windowHeight = window.innerHeight;
      windowRatio = windowHeight / windowWidth * 100;

      homeHeroRatio($homeHero);
    }

    if ($heroSliderWrap.length) {
      windowWidth = window.innerWidth;
      windowHeight = window.innerHeight;
      windowRatio = windowHeight / windowWidth * 100;

      homeHeroRatio($heroSliderWrap);
    }

    if ($hero.length) {
      windowWidth = window.innerWidth;
      windowHeight = window.innerHeight;
      windowRatio = windowHeight / windowWidth * 100;

      heroRatio($hero);
    }

    if ($contentGrouping.length) {
      contentGroupingRatio();
    }
  });

  /* Window Scroll */

  $(window).scroll(function () {

    if ($statusMessage.length) {
      scrollPos = $(window).scrollTop();

      if (scrollPos > 200) {
        $statusMessage.addClass('hidden');
      }
      else {
        $statusMessage.removeClass('hidden');
      }
    }
  });

  /* Window Load */

  $(window).on('load', function () {

    windowWidth = window.innerWidth;

    if (windowWidth <= 767) {

      if ($articlePreview.length) {
        $articlePreview.prependTo('.section.paragraphs');
      }
    }
  });

  /* DRUPAL BEHAVIORS */
  Drupal.behaviors.citysearch = {
    attach: function () {
      $('.block-nav-cities-regions input[data-drupal-selector=edit-nav-city-search], .block-list-cities-regions input[data-drupal-selector=edit-city-search]').on('autocompleteclose', function (e, ui) {
        var str = e.target.value;
        var match = str.match(/\((\d*)\)/);

        if (match) {
          $(this).val(str.replace(match[0], ''));
          window.location.href = '/node/' + match[1];
        }
      });

      $('#block-tnv-nav-citysearch-form').on('submit', function (e) {
        e.preventDefault();
        if ($('.ui-autocomplete a').length === 1) {
          $('.ui-autocomplete a').click();
        }
      });
    }
  };

  $(document).on('acquiaLiftWebSegments', function (event, segments, currentCapture) {
    if (segments !== null) {
      for (var i = 0; i < segments.length; i++) {
        if (segments[i] === 'crm_first_page_view') {
          $('body').addClass('first-time');
          $('body').addClass('interaction-form--disabled');
        }
      }
    }
  });

  Drupal.behaviors.clickevent = {
    attach: function () {

      // Provide reusable scroll-to-element class.
      $(once('anchorScrolltoID', 'a.js-action-scroll-to-id')).click(function () {
        var link_hash = $(this).attr('href').replace(/^.*?(#|$)/, '');

        if (link_hash.length > 0) {
          $('html, body').animate({scrollTop: $('[id=' + link_hash + ']').offset().top - 100}, 400);
        }

        return false;
      });

      document.onclick = function () {
        checkCookie();
      };

      $(once('closepop', '#block-emailinteractionspopup .close-link a')).click(function (e) {
        e.preventDefault();
        setCookie('tnvactive', '0', 30);
        hideEmailPopUp();
      });
    }
  };

  Drupal.behaviors.focusBehaviors = {
    attach: function (context, settings) {
      function focusKeyDown(e) {
        if ([9, 13, 32, 38, 40].indexOf(e.keyCode) !== -1) {
          $('body').addClass('jsa-keyboard-activated');
          $(window).on('mousedown.keyboard', focusMouseDown);
          $(window).off('keydown.keyboard');
        }
      }

      function focusMouseDown(e) {
        $('body').removeClass('jsa-keyboard-activated');
        $(window).on('keydown.keyboard', focusKeyDown);
        $(window).off('mousedown.keyboard');
      }

      $(window).on('keydown.keyboard', focusKeyDown);
    }
  };

  // Lighthouse - Use passive listeners to improve scrolling performance - workaround to editing jquery.js.
  jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
      this.addEventListener('touchstart', handle, {passive: !ns.includes('noPreventDefault')});
    }
  };
  jQuery.event.special.touchmove = {
    setup: function (_, ns, handle) {
      this.addEventListener('touchmove', handle, {passive: !ns.includes('noPreventDefault')});
    }
  };
  jQuery.event.special.wheel = {
    setup: function (_, ns, handle) {
      this.addEventListener('wheel', handle, {passive: true});
    }
  };
  jQuery.event.special.mousewheel = {
    setup: function (_, ns, handle) {
      this.addEventListener('mousewheel', handle, {passive: true});
    }
  };

})(jQuery, once); // eslint-disable-line no-undef
